import { EProductType, TProduct } from "./products.type";

export type TProductWithIntegrationRef = Pick<
  TProduct,
  "type" | "product_integration_ref"
>;

export function isInfinityAssistanceProduct(
  product: TProductWithIntegrationRef | null | undefined,
): boolean {
  return (
    product?.type === EProductType.INSURANCE_ASSISTANCE &&
    typeof product.product_integration_ref === "string" &&
    product.product_integration_ref.trim() !== ""
  );
}

